"use client"

import { toolByName } from "@/app/(marketing)/_data/tools"
import type { useCases } from "@/app/(marketing)/use-cases/_data/use-cases"
import { type Language, t } from "@/app/(marketing)/use-cases/_lib/i18n"
import Image from "next/image"
import Link from "next/link"

export function UseCaseCard({
  uc,
  language,
  onCardClick,
  animate,
}: {
  uc: (typeof useCases)[number]
  language: Language
  onCardClick: (e: React.MouseEvent, href: string) => void
  animate?: boolean
}) {
  return (
    <Link
      href={`/use-cases/${uc.slug}`}
      onClick={(e) => onCardClick(e, `/use-cases/${uc.slug}`)}
      className={`group rounded-2xl border border-gray-200 p-6 hover:shadow-lg hover:border-gray-300 transition-all duration-200 flex flex-col ${
        animate ? "animate-card-fade-in" : ""
      }`}
    >
      <h3 className="text-base font-semibold mb-2" style={{ color: "#26251f" }}>
        {t(language, uc.title.ja, uc.title.en, uc.title.zh)}
      </h3>
      <p className="text-sm leading-relaxed mb-4 line-clamp-3 flex-1" style={{ color: "#666" }}>
        {t(language, uc.description.ja, uc.description.en, uc.description.zh)}
      </p>
      {uc.tools.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-auto">
          {uc.tools.map((tool) => {
            const info = toolByName[tool]
            return (
              <span
                key={tool}
                className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gray-50 border border-gray-100 text-xs"
                style={{ color: "#666" }}
              >
                {info && (
                  <Image
                    src={info.logo}
                    alt={info.name}
                    width={14}
                    height={14}
                    className="w-3.5 h-3.5 object-contain"
                  />
                )}
                {tool}
              </span>
            )
          })}
        </div>
      )}
    </Link>
  )
}
